import { Link, useSearchParams } from 'react-router-dom';
import { AdminGbpAccess } from './AdminGbpAccess';
import { AdminGbpActions } from './AdminGbpActions';
import { AdminIntegrations } from './AdminIntegrations';
import { useAuth } from '../lib/auth';
import { T, sharedStyles } from '../components/Shared';

type GbpTab = 'accounts' | 'locations' | 'worklist';

const TABS: GbpTab[] = ['accounts', 'locations', 'worklist'];

export function AdminGbpManagement() {
  const [params, setParams] = useSearchParams();
  const { user } = useAuth();
  // The worklist returns the entire book in one payload for bulk export, so it
  // is admin-only. This hides the tab; /api/gbp-actions enforces the same rule
  // server-side, which is what actually protects the data.
  const isAdmin = user?.role === 'admin';
  const raw = params.get('tab');
  const requested: GbpTab = TABS.includes(raw as GbpTab) ? raw as GbpTab : 'accounts';
  const tab: GbpTab = requested === 'worklist' && !isAdmin ? 'accounts' : requested;
  const setTab = (next: GbpTab) => {
    const updated = new URLSearchParams(params);
    updated.set('tab', next);
    setParams(updated, { replace: true });
  };

  return (
    <div style={{ height: '100vh', overflowY: 'auto', background: '#f8f9fa', padding: '40px 32px' }}>
      <div style={{ maxWidth: 1080, margin: '0 auto' }}>
        <Link to="/admin" style={{ fontSize: 12, color: T.fgSecondary, textDecoration: 'none' }}>← Back to clients</Link>
        <div style={{ fontFamily: sharedStyles.fontDisplay, fontSize: 28, fontWeight: 700, color: T.fgPrimary, marginTop: 8, marginBottom: 4 }}>
          GBP Management
        </div>
        <div style={{ fontSize: 13, color: T.fgSecondary, marginBottom: 18, lineHeight: 1.5 }}>
          Connected accounts are the Google logins GBI uses to access managed Business Profiles. Locations are the GBP locations discovered from those accounts and their Client/Intake status.{isAdmin && ' The action worklist is every client\'s stored analysis and action plan in one sweepable list.'}
        </div>
        <div style={{ display: 'flex', borderBottom: `1px solid ${T.border}`, marginBottom: 22 }}>
          <Tab active={tab === 'accounts'} onClick={() => setTab('accounts')}>Connected accounts</Tab>
          <Tab active={tab === 'locations'} onClick={() => setTab('locations')}>Locations</Tab>
          {isAdmin && <Tab active={tab === 'worklist'} onClick={() => setTab('worklist')}>Action worklist</Tab>}
        </div>
        {tab === 'accounts' && <AdminIntegrations embedded />}
        {tab === 'locations' && <AdminGbpAccess embedded />}
        {tab === 'worklist' && isAdmin && <AdminGbpActions embedded />}
      </div>
    </div>
  );
}

function Tab({ active, onClick, children }: { active: boolean; onClick: () => void; children: React.ReactNode }) {
  return (
    <button onClick={onClick} style={{
      border: 'none', borderBottom: active ? `2px solid ${T.cyan}` : '2px solid transparent',
      background: 'transparent', color: active ? T.cyanDim : T.fgSecondary, padding: '9px 14px',
      marginBottom: -1, cursor: 'pointer', fontSize: 13, fontWeight: active ? 700 : 500,
    }}>{children}</button>
  );
}
